define('utils/youtube-video-loader', [
    'jquery',
    'underscore',
],  function ($, _) {
    'use strict';

    console.log('%cfile: youtube-video-loader.js', 'color: #C2ECFF');

    var youtubeVideoLoader = function youtubeVideoLoader(){
        console.log('%ctrace: youtubeVideoLoader', 'color: #ccc');

        var el = '[data-youtube-video-loader]',
            link = '[data-youtube-video-loader-link]';

        var $el = $(el),
            $link = $(link);

        if($el.length <= 0){
            console.warn('%ctrace: contentSlider: not found dom elements', 'color: #ccc');
            return false;
        }

        $el.each(function(i, el){
            initialize($(el));
        });

        function initialize($el){

            $link.off('click').on('click', function(e){
                e.preventDefault();

                var parameters = {};
                parameters.videoId = $(this).attr('data-youtube-video-loader-link');

                var template = _.template($('#template-youtube-video').html());
                $el.html(template(parameters));
            });
        }
    };

    return youtubeVideoLoader;
});

